import { useTranslations } from "@jugl-web/utils";
import React from "react";
import { TextInput } from "@jugl-web/ui-kit";
import { Controller, useFormContext } from "react-hook-form";
import { MAX_CTA_LENGTH } from "@jugl-web/domain-resources/chat-bot/consts";
import { AppearanceSettingsTabShell } from "../AppearanceSettingsTabShell";
import { TabHeader } from "../../../../components/TabHeader";
import { Separator } from "../../../../components/Separator";
import { CTAVisualSection } from "../../../../components/CTAVisualSection";
import { LiveChatAppSettingsFormValues } from "../../types";

export const ChatStarterTabContent: React.FC = () => {
  const { t } = useTranslations();

  return (
    <AppearanceSettingsTabShell tabId="chatStarter">
      <TabHeader
        title={t({
          id: "client-support-page.chat-starter",
          defaultMessage: "Chat Starter",
        })}
        subtitle={t({
          id: "client-support-page.chat-starter-description",
          defaultMessage:
            "Set the proper Welcome message to engage users for the conversation",
        })}
      />
      <Separator className="my-8" />
      <ChatStarterTabContentInner />
    </AppearanceSettingsTabShell>
  );
};

const ChatStarterTabContentInner: React.FC = () => {
  const { t } = useTranslations();
  const { control, setValue, watch } =
    useFormContext<LiveChatAppSettingsFormValues>();

  const ctaVisual = watch("ctaVisual");

  return (
    <>
      <div className="flex flex-col gap-6">
        <Controller
          control={control}
          name="ctas.0"
          render={({ field: { onChange, ...props } }) => (
            <TextInput
              placeholder={t({
                id: "common.enter",
                defaultMessage: "Enter",
              })}
              label={t({
                id: "client-support-page.main-title",
                defaultMessage: "Main Title",
              })}
              isRequired
              labelPosition="border-overlap"
              classNames={{
                wrapperClassName: "w-full",
              }}
              lengthIndicator={{
                max: MAX_CTA_LENGTH,
              }}
              maxLength={MAX_CTA_LENGTH}
              onChange={(e) => onChange(e.target.value.trimStart())}
              {...props}
            />
          )}
        />
        <Controller
          control={control}
          name="ctas.1"
          render={({ field: { onChange, ...props } }) => (
            <TextInput
              placeholder={t({
                id: "common.enter",
                defaultMessage: "Enter",
              })}
              label={t({
                id: "client-support-page.additional-text",
                defaultMessage: "Additional Text",
              })}
              labelPosition="border-overlap"
              classNames={{
                wrapperClassName: "w-full",
              }}
              lengthIndicator={{
                max: MAX_CTA_LENGTH,
              }}
              maxLength={MAX_CTA_LENGTH}
              onChange={(e) => onChange(e.target.value.trimStart())}
              {...props}
            />
          )}
        />
      </div>
      <Separator className="my-10" />
      <CTAVisualSection
        value={ctaVisual}
        onChange={(value) =>
          setValue("ctaVisual", value, { shouldDirty: true })
        }
      />
    </>
  );
};
